// import React, { useRef, useState } from "react";
// import classes from "./Login.module.css";

// import littleImage from "../../Assets/Little_logo_login.png";
// import ForgotPassword from "./ForgotPassword";
// import { useEffect } from "react";
// import useHttp from "../../Hooks/use-http";
// import { useCallback } from "react";
// import useOnlineStatus from "../../Hooks/useOnlineStatus";

// let DATA_ERROR = {
//   emailError: "",
//   passwordError: "",
// };
// let fromIsValid = true;
// let jay = 0;

// const Login = ({ login }) => {
//   const emailInputRef = useRef();
//   const passwordInputRef = useRef();
//   const [isForgotPasswordClicked, setIsForgotPasswordClicked] = useState(false);
//   const [formError, setFormError] = useState(DATA_ERROR);
//   const [isCall, setIsCall] = useState();
//   const [isApiError, setIsApiError] = useState();

//   // const onlineStatus = useOnlineStatus();
//   // console.log(onlineStatus);

//   const authenticateUser = (data) => {
//     // localStorage.setItem("privateDriverFlag", false);
//     // alert("hrllo");
//     // console.log(data);
//     if (!data.Message) setIsApiError(data + " Please try again later");
//     else {
//       localStorage.setItem("userType", data.UserType);
//       localStorage.setItem("user", emailInputRef.current.value);
//       localStorage.setItem("adminName", data.Username);
//       localStorage.setItem("roleId", data.RoleID);
//       localStorage.setItem("adminDepartmentID", data.AdminDepartmentID);
//       localStorage.setItem("corpId", data.CorporateID);
//       sessionStorage.setItem("type", data.UserType);
//       sessionStorage.setItem("document", data.IsDocument);
//       localStorage.setItem("cpName", data.CorporateName);
//       localStorage.setItem("enabledModule", data.EnabledModule);
//       localStorage.setItem("corporateAddress", data.CorporateAddress);
//       localStorage.setItem("corporateImage", data.CorporateImage);
//       localStorage.setItem("userImage", data.UserImage);
//       localStorage.setItem("shiftStartOTPFromLocalStorage", JSON.parse(data.ParameterJSON)?.shiftStartOTP);
//       localStorage.setItem("shiftEndOTPFromLocalStorage", JSON.parse(data.ParameterJSON)?.shiftEndOTP);

//       setIsCall(false);
//       data.Message === "Success"
//         ? login(true)
//         : setIsApiError("Please enter valid email or password");
//     }
//   };

//   const { isLoading, sendRequest } = useHttp();
//   // setTimeout(() => {
//   //   isLoading
//   //     ? (document.getElementById("loginButton").disabled = true)
//   //     : (document.getElementById("loginButton").disabled = false);
//   // });

//   useEffect(() => {
//     if (isLoading) {
//       document.getElementById("loginButton").disabled = true;
//     } else {
//       document.getElementById("loginButton").disabled = false;
//     }
//   }, [isLoading]);

//   useEffect(() => {
//     if (isCall)
//       sendRequest(
//         {
//           url: "/api/v1/Authentication/AuthenticateUser",
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: {
//             emailID: emailInputRef.current.value,
//             password: passwordInputRef.current.value,
//           },
//         },
//         authenticateUser
//       );
//   }, [isCall, sendRequest]);

//   const loginHandler = (event) => {
//     event.preventDefault();
//     // !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3,4,5,6,7})+$/.test(
//     if (
//       // eslint-disable-next-line
//       !/\S+@\S+\.\S+/.test(emailInputRef.current.value)
//     ) {
//       // eslint-disable-line
//       fromIsValid = false;
//       setFormError((prev) => ({ ...prev, emailError: "Email is Invalid" }));
//     }
//     if (passwordInputRef.current.value.length < 8) {
//       fromIsValid = false;
//       setFormError((prev) => ({
//         ...prev,
//         passwordError: "Password must be of 8 character",
//       }));
//     }
//     if (emailInputRef.current.value && passwordInputRef.current.value) {
//       // fromIsValid && login(true);
//       fromIsValid && setIsCall((prev) => !prev);
//     }
//   };

//   const emailChangeHandler = () => {
//     setIsApiError("");
//     if (
//       // eslint-disable-next-line
//       /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/.test(
//         emailInputRef?.current?.value
//       )
//     ) {
//       // eslint-disable-line
//       fromIsValid = true;
//       setFormError((prev) => ({ ...prev, emailError: "" }));
//     } else fromIsValid = false;
//   };

//   const passwordChangeHandler = () => {
//     setIsApiError("");
//     if (passwordInputRef.current.value.length >= 8) {
//       fromIsValid = true;
//       setFormError((prev) => ({ ...prev, passwordError: "" }));
//     } else fromIsValid = false;
//   };

//   const forgotPasswordHandler = () => {
//     setIsForgotPasswordClicked(true);
//   };
//   return (
//     <div className={classes.loginContainer}>
//       <img src={littleImage} alt="" className={classes.logo} />
//       <div className={classes.text}>Access Your Corporate Account</div>
//       <p className={classes.errorMessage}>{isApiError}</p>
//       {/* <form className={classes.form} onSubmit={loginHandler}> */}
//       <form className={classes.form}>
//         {!isForgotPasswordClicked && (
//           <React.Fragment>
//             <input
//               type="text"
//               placeholder="Email"
//               className={classes.input}
//               ref={emailInputRef}
//               onChange={emailChangeHandler}
//             />
//             {formError && (
//               <p className={classes.errorMessage}>{formError.emailError}</p>
//             )}
//             <input
//               type="password"
//               placeholder="Password"
//               className={classes.input}
//               ref={passwordInputRef}
//               onChange={passwordChangeHandler}
//             />
//             {formError && (
//               <p className={classes.errorMessage}>{formError.passwordError}</p>
//             )}
//             <div
//               className={classes.forgotPassword}
//               onClick={forgotPasswordHandler}
//             >
//               Forgot password?
//             </div>
//             {/* <input id="loginButton" /> */}
//             <input
//               id="loginButton"
//               type="submit"
//               value={isLoading ? "Loading..." : "Login"}
//               className={classes.loginButton}
//               onClick={loginHandler}
//             />
//           </React.Fragment>
//         )}
//         {isForgotPasswordClicked && (
//           <React.Fragment>
//             <ForgotPassword forgotPassword={setIsForgotPasswordClicked} />
//           </React.Fragment>
//         )}
//       </form>
//       {/* <iframe style={{ position: "absolute", width: "100%", height: "100%", zIndex: "999" }} src="https://chromedino.com/" frameborder="0" scrolling="no" width="100%" height="100%" loading="lazy"></iframe> */}
//     </div>
//   );
// };

// export default Login;

// New API Implementation
import React, { useRef, useState, useEffect } from "react";
import classes from "./Login.module.css";
import littleImage from "../../Assets/Little_logo_login.png";
import ForgotPassword from "./ForgotPassword";
import useHttp from "../../Hooks/use-http";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
// import { encryptToken } from "../encyptionDecryption";
import { setCookie } from "../Utils/CookiesUtils";

const INITIAL_ERRORS = {
  emailError: "",
  passwordError: "",
};

const Login = ({ login }) => {
  const emailInputRef = useRef();
  const passwordInputRef = useRef();
  const [isForgotPasswordClicked, setIsForgotPasswordClicked] = useState(false);
  const [formError, setFormError] = useState(INITIAL_ERRORS);
  const [isCall, setIsCall] = useState(false);
  const [isApiError, setIsApiError] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const { isLoading, sendRequest } = useHttp();

  const authenticateUser = (data) => {
    setIsCall(false); // ✅ Reset so next login can trigger again

    if (data.status === 200) {
      setCookie("token", data.token, 2);

      localStorage.setItem("userType", data.user.userType);
      localStorage.setItem("user", emailInputRef.current.value);
      localStorage.setItem("roleId", data.user.roleID);
      sessionStorage.setItem("type", data.user.userType);
      // localStorage.setItem(
      //   "adminName",
      //   `${data.user.firstName} ${data.user.lastName}`
      // );
      localStorage.setItem("adminName", `${data.user.firstName} ${data.user.lastName}`);
      localStorage.setItem("corpId", data.user.corporateID);
      localStorage.setItem("cpName", data.user.corporateName);
      localStorage.setItem("adminDepartmentID", data.user.departmentID);
      localStorage.setItem("userImage", data.user.profilePic);
      localStorage.setItem("corporateLogo", data.user.corporateLogo);
      localStorage.setItem("enabledModule", data.user.enabledModule);
      localStorage.setItem("roleDisplayName", data.user.roleDisplayName);

      // Additional data handling can go here
      login(true); // Trigger successful login callback
    } else {
      setIsApiError(data.Message || "Invalid email or password");
    }
  };

  useEffect(() => {
    const loginButton = document.getElementById("loginButton");
    loginButton.disabled = isLoading;
  }, [isLoading]);

  useEffect(() => {
    if (isCall) {
      sendRequest(
        {
          url: "/login",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: {
            emailID: emailInputRef.current.value,
            password: passwordInputRef.current.value,
          },
        },
        authenticateUser
      );
    }
  }, [isCall, sendRequest]);

  const loginHandler = (event) => {
    event.preventDefault();
    setFormError(INITIAL_ERRORS);
    let formIsValid = true;

    const email = emailInputRef.current.value;
    const password = passwordInputRef.current.value;

    // Validate email format
    if (!/\S+@\S+\.\S+/.test(email)) {
      formIsValid = false;
      setFormError((prev) => ({ ...prev, emailError: "Email is invalid" }));
    }

    // Validate password length
    if (password.length < 3) {
      formIsValid = false;
      setFormError((prev) => ({
        ...prev,
        passwordError: "Password must be at least 8 characters",
      }));
    }

    // If form is valid, initiate API call
    if (formIsValid) {
      setIsCall(true);
    }
  };

  const handleInputChange = (setter) => (event) => {
    setter(event.target.value);
    setIsApiError(""); // Reset API error on input change
  };

  const forgotPasswordHandler = () => {
    setIsForgotPasswordClicked(true);
  };

  return (
    <div className={classes.loginContainer}>
      <img src={littleImage} alt="Logo" className={classes.logo} />
      <div className={classes.text}>Access Your Corporate Account</div>
      <p className={classes.errorMessage}>{isApiError}</p>
      <form className={classes.form} onSubmit={loginHandler}>
        {!isForgotPasswordClicked ? (
          <>
            <input
              type="text"
              placeholder="Email"
              className={classes.input}
              ref={emailInputRef}
              onChange={handleInputChange((value) => {
                if (/\S+@\S+\.\S+/.test(value)) {
                  setFormError((prev) => ({ ...prev, emailError: "" }));
                }
              })}
            />
            {formError.emailError && (
              <p className={classes.errorMessage}>{formError.emailError}</p>
            )}
            <div className={classes.passwordContainer}>
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                className={classes.input}
                ref={passwordInputRef}
                onChange={handleInputChange((value) => {
                  if (value.length >= 8) {
                    setFormError((prev) => ({ ...prev, passwordError: "" }));
                  }
                })}
              />
              <span
                className={classes.visibilityIcon}
                onClick={() => setShowPassword((prev) => !prev)}
              >
                {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
              </span>
            </div>
            {formError.passwordError && (
              <p className={classes.errorMessage}>{formError.passwordError}</p>
            )}
            <div
              className={classes.forgotPassword}
              onClick={forgotPasswordHandler}
            >
              Forgot password?
            </div>
            <input
              id="loginButton"
              type="submit"
              value={isLoading ? "Loading..." : "Login"}
              className={classes.loginButton}
            />
          </>
        ) : (
          <ForgotPassword forgotPassword={setIsForgotPasswordClicked} />
        )}
      </form>
    </div>
  );
};

export default Login;
